export default "__VITE_ASSET__IgfwBbBf__"